import React from "react";

import styled from "styled-components/macro";

import FnrButton3 from "UI/FnrButton3";

export default function SelectionComplete({
  handleClose,
  columnTitle,
  selectedBoardName,
  goToReport,
}) {
  return (
    <Stack>
      <SuccessText>
        <em>{`${columnTitle}`}</em> has been added to{" "}
        <em>{`${selectedBoardName}`}</em>
      </SuccessText>
      <Row justifyContent="space-between">
        <FnrButton3 onClick={handleClose} color="gray">
          Close
        </FnrButton3>
        <FnrButton3 onClick={goToReport} color="green">
          Go to Report
        </FnrButton3>
      </Row>
    </Stack>
  );
}

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const SuccessText = styled.p`
  font-size: 1.25rem;

  em {
    font-weight: 600;
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: ${(p) => p.justifyContent || "flex-start"};
  align-items: center;
  gap: 6px;
  padding-inline: ${(p) => p.paddingInline || 0};
`;
